import {ButtonEvent} from "slotworks/graphics/elements/button-element";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import CampaingsModel from "slotworks/integration/revolver/model/campaigns-model";
import AutoplayModel from "slotworks/model/autoplay-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import SmartButton, {SmartButtonFlag} from "slotworks/smart-button/smart-button";
import StateMachine from "slotworks/state-machine/state-machine";
import Components from "../../components/components";

export default class PromoSpinButtonBehaviour extends AbstractButtonBehaviour {

   private label: FlexiText;

    constructor() {
        super();
    }

    public init() {
        // Spin button

        Layers.SmartButton.setScene("promo").execute();

        this.button = Layers.SmartButton.getFlexiButton("spin_promo");
        this.label = Layers.SmartButton.getFlexiText("label-stop");
        Layers.SmartButton.getFlexiText("label-spin").setVisible(true);
        this.button.setVisible(true);
        this.button.setEnabled(true);
        this.label.setVisible(false);

        this.button.on(ButtonEvent.POINTER_DOWN, this.onDownListener);

        document.addEventListener("keyup", this.onKeyUpListener);
    }

    public destroy() {
        this.button.off(ButtonEvent.POINTER_DOWN, this.onDownListener);
        this.label.setVisible(true);
        document.removeEventListener("keyup", this.onKeyUpListener);
        super.destroy();
    }

    private onKeyUpListener = (event: any) => {
        if (SettingsModel.getSpaceToSpin()) {
            if (event.keyCode === 32) {
                this.spin();
            }
        }
    }

    private onDownListener = () => {
        this.spin();
    }

    private spin = () => {
        Components.promoBetBar.setEnabled(false);
        Layers.PromoPopups.hide();

        const autoplays = CampaingsModel.freespins.remaining;
        AutoplayModel.setAutoplays(autoplays);
        AutoplayModel.confirm();

        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN, true);

        StateMachine.skip();
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/smart-button/behaviours/promo-fs-start-button-behaviour.ts